<template>
  <validation-observer ref="simpleRules">
    <item-form />
    <tenant-modal :refresh-data="getData" />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus"
    />
  </validation-observer>
</template>
<script>
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ItemForm from '@/views/Admin/Estates/ItemForm.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import toastMixin from '@/libs/toast'
import TenantModal from '@/views/Admin/Estates/elements/TenantModal.vue'

export default {
  name: 'Edit',
  components: {
    TenantModal,
    ItemForm,
    SaveButton,
    ValidationObserver,
  },
  mixins: [toastMixin],
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
    saveData() {
      return this.$store.getters['estates/dataSaveStatus']
    },
    estateTenants() {
      return this.$store.getters['estateTenants/dataItem']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({ template: 'saveSuccess' })
        // this.$router.push('/app/estates')
        this.getData()
        this.$store.commit('estateTenants/RESET_DATA_ITEM')
      } else if (val.status === false) {
        this.showToast({ template: 'saveError' })
      }
    },
  },
  created() {
    this.getData()
    this.$store.commit('estateTenants/RESET_DATA_ITEM')
    localize('tr')
  },
  methods: {
    getData() {
      this.$store.dispatch('estates/getDataItem', this.$route.params.id)
        .then(response => {
          if (response.id_cities) {
            this.$store.dispatch('districts/getDataList', {
              select: [
                'districts.id AS id',
                'districts.title AS title',
              ],
              where: {
                'districts.id_cities': this.dataItem.id_cities,
              },
            })
          }
        })
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.dataItem.tenants = this.estateTenants
          this.$store.dispatch('estates/saveData', this.dataItem)
        } else {
          this.showToast({ template: 'requireWarning' })
        }
      })
    },
  },
}
</script>
